/* Lahore Furniture: WhatsApp quote selector, 10Techies unpublished draft.
   Shopify's native selling price remains unchanged until price variants are migrated. */
(()=>{'use strict';
const money=cents=>'Rs.'+new Intl.NumberFormat('en-PK',{maximumFractionDigits:0}).format(Math.round(cents/100));
/* Keep Shopify release-preview links on the candidate theme across page navigation. */
try {
 const preview=new URLSearchParams(window.location.search).get('preview_theme_id');
 if(preview && /^[0-9]+$/.test(preview))sessionStorage.setItem('tt-preview-theme-id',preview);
}catch(_){}

function quoteCheckoutPath(){
 let id=new URLSearchParams(window.location.search).get('preview_theme_id');
 try{if(id)sessionStorage.setItem('tt-preview-theme-id',id);else id=sessionStorage.getItem('tt-preview-theme-id');}catch(_){}
 return id&&/^[0-9]+$/.test(id)?'/pages/checkout-whatsapp?preview_theme_id='+encodeURIComponent(id):'/pages/checkout-whatsapp';
}
document.addEventListener('click',e=>{const a=e.target.closest?.('a[href^="/pages/checkout-whatsapp"]');if(a)a.setAttribute('href',quoteCheckoutPath());},true);

function init(root){
 if(root.dataset.ttInitialized==='yes')return;
 root.dataset.ttInitialized='yes';
 const container=root.closest('.product__info-container')||root.closest('product-info');
 const formId=root.dataset.ttFormId;
 const form=document.getElementById(formId);
 const standard=Number(root.dataset.ttStandard);
 const same=Number(root.dataset.ttSame);
 const original=Number(root.dataset.ttOriginal);
 if(!Number.isFinite(original)||original<=0)return;
 let prop=form?.querySelector('input[name="properties[Delivery Offer]"]');
 if(form&&!prop){prop=document.createElement('input');prop.type='hidden';prop.name='properties[Delivery Offer]';form.append(prop);}
 const set=()=>{
  const chosen=root.querySelector('input[data-tt-choice]:checked');
  if(!chosen)return;
  const isSame=chosen.value==='same', current=isSame?same:standard;
  const mode=isSame?'Same-Day Delivery (40% OFF)':'Standard Order (20% OFF)';
  if(prop)prop.value=mode;
  /* Sticky add-to-cart must carry the same WhatsApp offer as the main form. */
  const productId=root.dataset.ttProductId||'';
  const sticky=/^[0-9]+$/.test(productId) ? document.querySelector('sticky-atc-bar[data-product-id="'+productId+'"]') : null;
  const stickyProp=sticky?.querySelector('input[name="properties[Delivery Offer]"]');
  if(stickyProp)stickyProp.value=mode;
  const stickySale=sticky?.querySelector('.sticky-atc-bar__product-info .f-price-item--sale');
  if(stickySale)stickySale.textContent=money(current);
  const selected=root.querySelector('[data-tt-selected]'), saving=root.querySelector('[data-tt-saving]');
  if(selected)selected.textContent=(isSame?'Same-Day Delivery':'Standard Order')+' selected — '+(isSame?'40%':'20%')+' OFF';
  if(saving)saving.textContent='You save '+money(original-current);
  const priceDisplay=container?.querySelector('[id^="price-"] .f-price-item--sale');
  if(priceDisplay)priceDisplay.textContent=money(current);
  const relatedBadge=container?.querySelector('.product__badges .f-badge--sale');
  if(relatedBadge)relatedBadge.textContent=isSame?'-40%':'-20%';
  const activated=container?.querySelector('[data-tt-activation]');
  if(activated)activated.hidden=!isSame;
  root.dataset.ttSelected=chosen.value;
 };
 root.querySelectorAll('input[data-tt-choice]').forEach(input=>input.addEventListener('change',set));
 set();
}
function scan(scope=document){if(scope.matches?.('[data-tt-delivery-offer]'))init(scope);scope.querySelectorAll?.('[data-tt-delivery-offer]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan());else scan();
document.addEventListener('shopify:section:load',e=>scan(e.target));
let queued=false;new MutationObserver(records=>{if(queued)return;if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-tt-delivery-offer]')||n.querySelector?.('[data-tt-delivery-offer]'))))){queued=true;requestAnimationFrame(()=>{queued=false;scan()})}}).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('click',async e=>{
 const button=e.target.closest?.('[data-tt-buy-whatsapp]');if(!button)return;
 e.preventDefault();if(button.disabled)return;
 const form=button.closest('form');if(!form)return;
 const id=Number(form.querySelector('input[name="id"]')?.value);
 const quantity=Math.max(1,Number(form.querySelector('input[name="quantity"]')?.value||1));
 const property=form.querySelector('input[name="properties[Delivery Offer]"]')?.value;
 if(!Number.isSafeInteger(id)||id<1||!Number.isSafeInteger(quantity)||quantity>99)return;
 button.disabled=true;button.textContent='Adding product…';
 try{
   const item={id,quantity,properties:property?{'Delivery Offer':property}:{}};
   const res=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
   if(!res.ok)throw new Error((await res.json().catch(()=>({}))).description||'Could not add the selected product.');
   window.location.assign(quoteCheckoutPath());
 }catch(err){button.disabled=false;button.textContent='Buy via WhatsApp';let msg=form.querySelector('.tt-wa-buy-error');if(!msg){msg=document.createElement('div');msg.className='tt-wa-buy-error';msg.setAttribute('role','alert');button.after(msg);}msg.textContent=err.message||'Please try again.';}
});
})();
